<footer> 
  <mat-card>&copy; Copyright {{currentYear}}, <span class="link">Shashi Badhuk</span></mat-card>
</footer> 